import { MutationGithubIntegrationUpdateArgs, VcsCheck } from "types/generated";

import { ManageGitHubManualFormFields } from "./types";
import { UpdateGitHubIntegrationData } from "./gql";

export const getFormDefaultValues = (
  integration?: UpdateGitHubIntegrationData
): ManageGitHubManualFormFields => {
  const useGitCheckoutValue = integration ? integration?.useGitCheckout : true;

  return {
    vcsChecks: integration?.vcsChecks || VcsCheck.Individual,
    useGitCheckout: useGitCheckoutValue,
  };
};

export const mapUpdateGitHubIntegrationInputValues = (
  values: ManageGitHubManualFormFields
): MutationGithubIntegrationUpdateArgs => ({
  vcsChecks: values.vcsChecks,
  useGitCheckout: values.useGitCheckout,
});
